import React from 'react';
import {useTable} from 'react-table';
import {Table} from 'reactstrap';
import Aux from '../../hoc/Auxiliary';

const BasicDataTable = ({columns, data}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,
        page,
    } = useTable(
        {
            columns,
            data,
            rows,
        }
    );

    return (
        <Aux>
            <div className="table-wrapper table-wrapper--nopadd">
                <Table hover {...getTableProps()} className="datatable">
                    <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <Aux key={row.getRowProps().key}>
                                <tr>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        );
                                    })}
                                </tr>
                            </Aux>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
        </Aux>
    );
};

export default BasicDataTable;
